export class BudgetFilter{
    recieverId: number;
    releasedById: number;
    dateRecieved: string;

    createdDate: string; // mm/dd/yyyy
    createdBy: number;
    updatedDate: string;
    updatedBy: number;
}


// WEBPACK FOOTER //
// ./src/app/models/budgets/budget.filter.ts